import { BrowserRouter, Routes, Route } from "react-router-dom";
import Giadung from "./Giadung/Giadung";
import Gdprivacy from "./Giadung/Gdprivacy";
import Homerut from "./Rut/Homerut";
import Uudai from "./Rut/Uudai";
import Rutonline from "./Rut/Rutonline";
import Baophi from "./Rut/Baophi";
import Quytrinhrut from "./Rut/Quytrinhrut";
import Travel from "./Travel/Travel";
import Privacy from "./Travel/Privacy";
import Hcm from "./Rut/Hcm";
import Ngoaithanh from "./Rut/Ngoaithanh";
import Giadung2 from "./Giadung/Giadung2";
import Tq from "./Rut/Tq";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Homerut />} />
          <Route path="/rutthetindung" element={<Ngoaithanh />} />
          <Route path="/rut-tien-the-tin-dung" element={<Tq />} />
          <Route path="/giadung" element={<Giadung />} />
          <Route path="/gia-dung2" element={<Giadung2 />} />
          <Route path="/privacy" element={<Gdprivacy />} />
          <Route path="/nhan-uu-dai" element={<Uudai />} />
          <Route path="/rut-online" element={<Rutonline />} />
          <Route path="/ruttienthetindunghcm" element={<Hcm />} />
          <Route path="/bao-phi" element={<Baophi />} />
          <Route path="/quy-trinh-rut" element={<Quytrinhrut />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/privacysiam" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
